import { FeatureFlag } from '../FeatureFlag';

export const enableInAppHelp = new FeatureFlag({
    key: 'enable-in-app-help',
    defaultValue: false,
});
